import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ListingModel } from '../../../features/companies/enum/company';
import { NavigationService } from '../../../services/navigation.service';
import { ConfigService } from '../../../helpers/config.service';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styles: ``
})
export class NotificationListComponent implements OnInit {
  notificationListModel: ListingModel = new ListingModel;
  totalNotifications: number = 0;
  notificationList: NotificationRecordInterface[] = [];
  loading: boolean = false;
  @Output() Nots_Readed: EventEmitter<boolean> = new EventEmitter();
  constructor(
    // public dialogRef: MatDialogRef<NotificationListComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private _config:ConfigService,
    private navService: NavigationService) {
    // this.notificationList = data.list;
    // this.totalNotifications = data.total;
  }

  ngOnInit(): void {
    this.GetNotificationsList()
  }


  GetNotificationsList() {
    this.loading = true;
    let model = { ...this.notificationListModel };
    model.page += 1;
    this.navService.GetNotifiactions(model).subscribe((result) => {
      this.notificationList = this.notificationList.concat(result.data.list);
      this.totalNotifications = result.data.total;
      this.loading = false;
      this.Nots_Readed.emit(true);

      if (model.page == 1) {
        this.MarkAllAsRead();
      }
    })
  }


  MarkAllAsRead() {
    this.navService.MarkAllNotificationsAsRead().subscribe((result) => {
    })
  }

  getNextPage() {
    if (this.totalNotifications > this.notificationList.length) {
      this.notificationListModel.page += 1;
      this.GetNotificationsList();
    }
  }

  onLinkClick(e: any, link: any) {
    e.preventDefault();
  }
  onNavigate(link: string) {
    if (link) {
      // this.dialogRef.close(this.Noti_readed);
      this._config.goTo(link);
    }

  }

}



export interface NotificationRecordInterface {
  not_id: number
  user_type: string
  is_seen: number
  web_link: any
  created_at: string
  message: string
  sub_title: any
  image: string
  user_name: string
}

